import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { Observable } from 'rxjs';
import { shareReplay, map } from 'rxjs/operators';
import moment from 'moment';
import { properties } from '../../../../environments/properties';
import { PaymentWallet } from 'ospg-payment-wallet';
import * as React from 'react'
import * as ReactDom from 'react-dom'
import { Router } from "@angular/router";
import { ZipcodeService } from "../../../shared/services/zipcode.service";
import { RegistrationSubscriptionService } from "../../../shared/services/registration-subscription.service";
import { FreshPassModalService } from "../../../shared/services/freshpass-modal.service";
import { AuthService } from "../../../shared/services/auth.service";
import { TermsContentComponent } from "../../../shared/components/terms-content/terms-content.component";
import { NotificationModalComponent } from "../../../shared/components/notification-modal/notification-modal.component";
import { _windowUtil, capitalize, pluralizeBannerName, convertCurrencyToWords } from '../../../shared/utils/ui-utils';
import { ParamService } from 'src/app/shared/services/param.service';
import { PlanCard } from 'src/app/shared/components/plan-card/plan-card.model';
import { LogService } from 'src/app/shared/services/log.service';

// jQuery
declare let $: any;

@Component({
  selector: 'app-subscribe-freshpass',
  templateUrl: './subscribe-freshpass.component.html',
  styleUrls: ['./subscribe-freshpass.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ZipcodeService, RegistrationSubscriptionService, FreshPassModalService]
})

export class SubscribeFreshpassComponent implements OnInit {
  @Input() userInfo: any;
  @Input() selectPlanStepRedirect: boolean;
  @ViewChild('backButton') backButtonRef: ElementRef<HTMLButtonElement>;
  public windowUtil = _windowUtil(window);
  public planType: string;
  public step: string = '';
  public zipHeading: string;
  public zipAltText: string;
  public zipCtaFreeTrial: string;
  public zipCtaRegular: string;
  public zipSolicitation: boolean;
  public zipDescription: string;
  public zipDescriptionSrLabel: string;
  public zipExtendedTrial: string;
  public noDeliveryZipDescription: string;
  public selectPlanZipSolicitation: boolean;
  public selectPlanZipSolicitationLabel: string;
  public selectPlanFreeTrialMessage: string;
  public selectPlanRegularMessage: string;
  public annualPlanDefaultRibbon: string;
  public annualPlanDescription: string;
  public annualPlanCtaFreeTrial: string;
  public annualPlanCtaRegular: string;
  public annualPlanIsDefaultPlan: string;
  public monthlyPlanDefaultRibbon: string;
  public monthlyPlanDescription: string;
  public monthlyPlanDescription2: string;
  public snapMonthlyPlanDescription: string;
  public snapMonthlyPlanDescriptionSpacing: string;
  public verifiedSnapMonthlyPlanDescription: string;
  public logoUrl: string;
  public logo: string;
  public scene7PresetLogoCenter: string = '?$lplogo$';
  public scene7PresetDefaulImage: string = '&defaultImage=Not_Available';
  public scene7PresetCCIcon: string = '?$ccicon$';
  public scene7PresetBackgroundImage: string = '?$lp-full-width$';
  public paymentNote: string;
  public paymentNoteNoTrial: string;
  public paymentTC: SafeHtml;
  public paymentTCDynamicTrial: string;
  public paymentTCNoTrial: SafeHtml;
  public tc: boolean = false;
  public apDefault: boolean;
  public ribbonLabel: string;
  public discountRibbonLabel: string;
  public renewalDate: string = 'Data unavailable';
  public tenders: any;
  public availablePlans: any;
  public availablePromoPlans: any;
  public selectedPlan: any;
  public availablePlansHTML = [];
  public availablePaymentPlans = [];
  public isActive: any;
  public landingUser: any;
  public isNewUser: boolean = false;
  public userCardInfo: any = {};
  public iFrameDoc: Document;
  public cvvErrorMessage: string = '';
  public storeId: any;
  public subscriptionAuthoringFields: any;
  public showZipcodeField: boolean = false;
  public changeZip: boolean = false;
  public displayErrorMessage: string = '';
  public isPlansLoading = false;
  public isStorePickupOnlyAvailable: boolean;
  public deliveryBanner: string;
  public currentBanner: string;
  public isSisterBannerAvailable = false;
  public b2BSisterBannerIsAvailable = false;
  public deliveryBannerPrefix = '';
  public deliveryBannerSuffix = '';

  public isUserEmployee = false;
  public employeeDiscountMessage: string;
  public isAnnualDiscountedPrice = false;
  public isMonthlyDiscountedPrice = false;
  public monthlyDiscountDuration = 0;
  public annualDiscountDuration = 0;
  public isExtendedTrial: boolean = false;
  public extendedTrialDuration: string;
  public regularTrialDuration: string;
  public trialDurationInt: number;
  public taxDescription: string;
  public trialDuration: string;
  public numberOfCallsBeingLoaded = 0;
  public showMiniSpinner: boolean = false;
  public zipcodeCTAButtons: string = '.fresh-pass__zipcode-cta';
  public isThemeBuilderEnabled: boolean = false;
  public enableFPSisterBanner = true;
  public enableEmployeeDiscount = false;
  /* If enabled plans data is fetched from v3 api call */
  public enablePlansV3 = false;
  public restrictedZipcodesList;
  public isZipcodeRestricted: boolean;
  public SELECT_PLAN = 'selectPlan';
  public SUBSCRIPTION_LANDING = 'subscriptionLanding';
  public SIGN_UP = 'signUp';
  public PAYMENT = 'payment';
  public SIGN_IN = 'signin';
  public CVV = 'cvv';
  public USER_SELECTED_PLAN_NAME = 'userSelectedPlanName';
  public DISCOUNT_CODE = 'discountCode';
  public DISCOUNT_CODE_PATH = 'discountCodePath';
  public ONE_PLAN_CAMPAIGN = 'onePlanCampaign';
  public AVAILABLE_PROMO_PLANS = 'availablePromoPlans';
  public PREBOOK_REQUEST = 'isPrebookPageRequest';
  public WEBSOURCE_PARAM = 'webSource';
  public WEBSOURCE_PATH = 'webSourcePath';

  public isPrebookReq = null;
  public plans$: Observable<any>;
  public isCampaignTitle: boolean = false;
  public campaignTitle: string = "";
  public promoDiscountCode: object;
  public isOnePlanCampaign: boolean = false;
  public isNoFreeTrial: boolean = false;
  public enableSnap: boolean;
  public isSnapVerified: boolean = false;
  public enableCheckbox: boolean = false;
  public displayCheckbox: boolean = false;
  public createAccountTemplate;
  public signInTemplate;
  public isLoggedInTokenValid = false;
  public isSnapEligibleForBanner = false;
  public subscriptionLanding = {
    discountedPriceTargetUser: false,
    discountedPriceOffer: null,
    discountedPriceZipDescription: null,
    discountedPriceStrike: null,
    discountedPriceZipDescriptionTax: null
  };
  public isBDA: boolean = false;

  @Input()
  zipcodeSubscription: string;
  clickedOnce: boolean = false;
  @Input()
  currentEnvironment;
  freshpassCreateAccountComponent;
  @ViewChild('subscriptionPaymentIframe') paymentiFrame: ElementRef;
  private signUpBeforeDate: string;
  analyticsNextStep: string = '';
  analyticsCurrentStep: string = 'landing';
  analyticsFirstLanding: boolean = false;
  private analyticsMonthlyPrice = 0;
  private analyticsAnnualPrice = 0;
  private analyticsCampaignType;
  // constants
  private NEW_USER: string = 'newUser';
  private MODE_CREATE_ACCOUNT: string = 'createAccount';
  private SUBSCRIPTION_LOCAL_STORAGE = 'abSubscription';
  private AVAILABLE_PLANS = 'availablePlans';
  private USER_SELECTED_PLAN = 'userSelectedPlan';
  bannerColor: string = '#DD1E25';
  isB2B;

  public checkBoxEnable;
  public isCheckBoxVisible;
  public openPopup;
  public routeToDashboard;
  public priceInfo = "";
  properties = properties;

  enableForUPlus = properties.featureFlags.enableForUPlus;
  programDisplayData = properties.featureFlags.enableForUPlus ? properties.programType.forUPlus : properties.programType.freshpass;

  public step2HeaderTitle: string;
  public FRESH_PASS : string;
  convertCurrencyToWords = convertCurrencyToWords;

  invalidBannerInput = false;

  webSource = {
    param: '',
    path: ''
  }

  constructor(public elementRef: ElementRef,
    public zipcodeService: ZipcodeService,
    public subscriptionService: RegistrationSubscriptionService,
    public zone: NgZone,
    private changeDetector: ChangeDetectorRef,
    public _freshpassModalService: FreshPassModalService,
    public authService: AuthService,
    private router: Router,
    private paramService: ParamService,
    private logService: LogService,
    private renderer: Renderer2) {

    this.currentBanner = this.paramService.banner;
    this.enablePlansV3 = true;
     this.zipHeading = this.programDisplayData?.subscribeData?.zipHeading?.replace('{banner}', capitalize(this.currentBanner));
    this.zipAltText = this.programDisplayData?.subscribeData?.zipAltText;
    this.zipCtaFreeTrial = this.programDisplayData?.subscribeData?.zipCtaFreeTrial;
    this.zipCtaRegular = this.programDisplayData?.subscribeData?.zipCtaRegular;
    this.zipSolicitation = true;
    this.zipExtendedTrial =this.programDisplayData?.subscribeData?.zipExtendedTrial;
    this.zipDescription = '';
    this.selectPlanZipSolicitation = false;
    this.noDeliveryZipDescription = this.programDisplayData?.subscribeData?.noDeliveryZipDescription;
    this.selectPlanZipSolicitationLabel = this.programDisplayData?.subscribeData?.selectPlanZipSolicitationLabel;
    this.selectPlanFreeTrialMessage = this.programDisplayData?.subscribeData?.selectPlanFreeTrialMessage;
    this.selectPlanRegularMessage = this.programDisplayData?.subscribeData?.selectPlanRegularMessage;
    this.annualPlanDefaultRibbon = this.programDisplayData?.subscribeData?.annualPlanDefaultRibbon;
    this.annualPlanDescription = this.programDisplayData?.subscribeData?.annualPlanDescription;
    this.snapMonthlyPlanDescription = this.programDisplayData?.subscribeData?.snapMonthlyPlanDescription;
    this.snapMonthlyPlanDescriptionSpacing = this.programDisplayData?.subscribeData?.snapMonthlyPlanDescriptionSpacing;
    this.annualPlanCtaFreeTrial = this.programDisplayData?.subscribeData?.annualPlanCtaFreeTrial;
    this.annualPlanCtaRegular = this.programDisplayData?.subscribeData?.annualPlanCtaRegular;
    this.annualPlanIsDefaultPlan = this.programDisplayData?.subscribeData?.annualPlanIsDefaultPlan;
    this.monthlyPlanDefaultRibbon = this.programDisplayData?.subscribeData?.monthlyPlanDefaultRibbon;
    this.monthlyPlanDescription = this.programDisplayData?.subscribeData?.monthlyPlanDescription;
    this.monthlyPlanDescription2 = this.programDisplayData?.subscribeData?.monthlyPlanDescription2;
    this.discountRibbonLabel = this.programDisplayData?.subscribeData?.discountRibbonLabel;
    this.paymentNote = this.programDisplayData?.subscribeData?.paymentNote;
    this.paymentNoteNoTrial = this.programDisplayData?.subscribeData?.paymentNoteNoTrial;
    this.logoUrl = '/';
    this.isThemeBuilderEnabled = true;
    this.enableFPSisterBanner = true;
    this.enableEmployeeDiscount = this.properties.featureFlags.enableEmployeeDiscount;
    this.restrictedZipcodesList = window['SWY']['configService']?.freshPassRestrictedZipcodes || this.properties.freshpassRestrictedZipcodes;
    this.enableSnap = properties.featureFlags.enableSnap;    
    this.step2HeaderTitle = this.programDisplayData?.subscribeData?.step2HeaderTitle?.replace('{Banner}', capitalize(this.currentBanner));
    this.FRESH_PASS = this.programDisplayData?.displayName?.replace('{Banner}', capitalize(this.currentBanner));
    this.logo = this.programDisplayData?.imageAssets?.subscribedPrimaryLogo;

    // ------------Add all authoring fields into this object.
    this.subscriptionAuthoringFields = {
      zipBackgroundImage: "https://images.albertsons-media.com/is/image/ABS/FreshPass-Landing-Page-Hero-Banner" + this.scene7PresetBackgroundImage + this.scene7PresetDefaulImage,
      paymentFreeTrialButtonCTA: this.programDisplayData?.subscriptionAuthoringFields?.paymentFreeTrialButtonCTA,
      paymentButtonCTA: this.programDisplayData?.subscriptionAuthoringFields?.paymentButtonCTA,
      thankYouPaymentDetailsLabel: this.programDisplayData?.subscriptionAuthoringFields?.thankYouPaymentDetailsLabel,
      thankYouSubscriptionLabel: this.programDisplayData?.subscriptionAuthoringFields?.thankYouSubscriptionLabel,
      thankYouMsg: this.programDisplayData?.subscriptionAuthoringFields?.thankYouMsg,
      changePlanLabel: this.programDisplayData?.subscriptionAuthoringFields?.changePlanLabel,
      changePlanLink: this.programDisplayData?.subscriptionAuthoringFields?.changePlanLink,
      updatePaymentLabel: this.programDisplayData?.subscriptionAuthoringFields?.updatePaymentLabel,
      updatePaymentLink: this.programDisplayData?.subscriptionAuthoringFields?.updatePaymentLink,
      showNowButtonLabel: this.programDisplayData?.subscriptionAuthoringFields?.showNowButtonLabel,
      showNowButtonLink: this.programDisplayData?.subscriptionAuthoringFields?.showNowButtonLink,
      selectPlanChangeZipcode: this.programDisplayData?.subscriptionAuthoringFields?.selectPlanChangeZipcode,
      selectPlanTitle: this.programDisplayData?.subscriptionAuthoringFields?.selectPlanTitle,
      selectPlanHeading: this.programDisplayData?.subscriptionAuthoringFields?.selectPlanHeading,
      freshpassHeading: this.programDisplayData?.subscriptionAuthoringFields?.freshpassHeading,
      freshpassHeading2: this.programDisplayData?.subscriptionAuthoringFields?.freshpassHeading2,
      selectPlanTaxes: this.programDisplayData?.subscriptionAuthoringFields?.selectPlanTaxes,
      selectPlanTaxesSnap: this.programDisplayData?.subscriptionAuthoringFields?.selectPlanTaxesSnap,
      accountTitle: this.programDisplayData?.subscriptionAuthoringFields?.accountTitle,
      freshPassNoDelivery: this.programDisplayData?.subscriptionAuthoringFields?.freshPassNoDelivery,
      freshPassBenefitsTitle: this.programDisplayData?.subscriptionAuthoringFields?.freshPassBenefitsTitle,
      paymentTitle: this.programDisplayData?.subscriptionAuthoringFields?.paymentTitle,
      restrictedZipDescription: this.programDisplayData?.subscriptionAuthoringFields?.restrictedZipDescription,
      sisterBannerDescription: this.programDisplayData?.subscriptionAuthoringFields?.sisterBannerDescription,
    };

    {
      window['SubscribeFreshpass'] = {
        zone: zone,
        component: this
      };
    }
  }

  @ViewChild('b2b') b2b: ElementRef;

  public handleSNAPAction() {
    this.router.navigate([this.programDisplayData?.urlPath?.SUBSCRIBE_PATH]);
    return;
  }
  public get isLoaderDisplayed() {
    return this.numberOfCallsBeingLoaded > 0;
  }

  checkAndExpressStoreFlag() {
    const { flags } = window['AB']['storeFlagsData'];
    if (flags.ecomStore && flags.ecomStore.storeFeatures && flags.ecomStore.storeFeatures.isExpressStore) {
      localStorage.setItem('isExpressStore', flags.ecomStore.storeFeatures.isExpressStore);
    }
  }

  ngOnInit(): void {
    this.currentEnvironment = this.subscriptionService.getEnvironment();
    this.checkIfB2B();
    //disable snap on b2b site
    this.enableSnap = this.isB2B ? false : properties.featureFlags.enableSnap;

    this.bannerColor = this.subscriptionService.getAndSetBannerColorText(this.currentBanner);
    this.termsHTMLChangeEvent();
    if (this.userInfo) {
      this.postUserInfo({...(this.userInfo), isTokenValid: this.authService.checkUserTokenValidity(this.userInfo)});
    }
  }

  termsHTMLChangeEvent() {
    $('#terms-nc').change(function (e) {
      if ($('#terms-nc').is(':checked')) {
        $('#create-account-btn-unified').removeClass('disabled');
        $('#create-account-btn-unified').removeAttr('disabled');
      } else {
        $('#create-account-btn-unified').addClass('disabled');
        $('#create-account-btn-unified').attr('disabled', 'disabled');
      }
      e.stopPropagation();
    });
  }

  postUserInfo(value) {
    if (value) {
      this.userInfo = value;
      if (value.isTokenValid) {
        this.isLoggedInTokenValid = true;
      } else {
        this.isLoggedInTokenValid = false;
      }

      $('.subscription-registration').parent().attr('role', 'main');
      $('.remove-rl-padding').removeAttr('role');

      const storeFlagsData = window['AB']['storeFlagsData'];
      if (!this.isObjectEmpty(storeFlagsData)) {
        this.checkAndExpressStoreFlag();
      } else {
        $(document).on('storeFlagsLoadComplete', () => {
          this.checkAndExpressStoreFlag();
        });
      }
      this.checkPrebookRedirect();
      this.getPreRequisiteUserData();
      this.isRestrictedZipcode();
    }
  }

  // --------------------------------------------------------------------------
  /**
   * Check if User is registered.
   */
  // --------------------------------------------------------------------------
  isUserAuthorized() {
    return this.isLoggedInTokenValid;
  }

  // --------------------------------------------------------------------------
  /**
   *  Landing Page prerequisite data based on user state,subscription and eligibility.
   */
  // --------------------------------------------------------------------------
  public getPreRequisiteUserData() {
    this.landingUser = {
      isAuthorized: this.isUserAuthorized(),
      intent: this.userInfo?.preference?.toLowerCase() || this.userInfo?.preferenceMode?.toLowerCase(),
      currentZipcode: this.userInfo?.shopZipcode || this.userInfo?.zipcode,
      isEligibleForFreeTrial: true,
      isStoreDeliveryAvailable: true
    };
    //if preferenceMode is delivery call checkTwoHourDelivery to update tile if 2 hour delivery is available.
    
    // check if user is redirected from partners page
    this.checkRedirectionPath();
    
    // to hide unlimited delivery tile when store delivery is not supported.
    let isStoreDeliveryAvailable = localStorage.getItem('isStoreDeliveryAvailable');
    if (isStoreDeliveryAvailable == 'false') {
      $("[data-type='delivery']").parent().addClass('d-none');
    }
    // adding class to subscription parent class to remove padding added for CLS through CSS.
    $('.subscription-registration').addClass('subscription-registration-wrapper');
    if (this.landingUser.isAuthorized) {
      // -- Listen for user info call completion before making logic related API calls.

      this.showLoader();
      // --------- Check if User is eligible for free trial
      this.getCustomerPreference().subscribe({
        next: (data) => {
          this.hideLoader();
          this.isActive = data;
          this.landingUser.isEligibleForFreeTrial = this.isActive && this.isActive['freeTrial'] === true ? true : false;
          if (this.isActive && this.isActive['subscription']) {
            //set local storage to display snackbar
            this.removePersistedInfo();
            this.setLocalStorageIfDiscountCampaignAndActive()
            // check if user is on a monthly subscription, if so, redirect to change plan page.
            if (this.webSource?.param && this.webSource?.path && this.isActive['subscriptionType'] === 'Monthly Plan') {
                this.redirectToChangePlanWithReferrerPath();
                return;
            } else {
              this.windowUtil.setWindowLocationHref(this.programDisplayData?.urlPath?.CONFIRMATION_PATH);
              return;
            }
          }
          // ------check if state param and subscription local storage exist.
          const stateUrlParam = window['AB']['COMMON'].getCookie('freshpassState');
          if (stateUrlParam && stateUrlParam === this.PAYMENT && window['AB']['COMMON'].isLSCompatible()) {
            // ------persist user selected values from localstorage.
            this.checkIfSubscriptionLocalStorageExist();
          } else {
            // set default step to subscription landing
            if (this.enableEmployeeDiscount || this.enablePlansV3) {
              this.analyticsFirstLanding = true;
            }
            this.checkStepRedirect();
          }
          // --------- Check if User is employee or not
          if (this.enableEmployeeDiscount) {
            this.getCustomerType().subscribe({
              next: (data) => {
                if (data) {
                  this.isUserEmployee = data;
                  this.fetchPlans();
                  if (this.analyticsFirstLanding === true) {
                    this.updateAnalytics('firstLanding');
                    this.analyticsFirstLanding = false;
                  }
                } else {
                  this.updateAnalytics('landing');
                  this.analyticsFirstLanding = false;
                }
              },
              error: (e) => console.error(e),
              complete: () => console.info('getCustomerType complete')
            });
          }
        },
        error: (e) => {
          this.checkStepRedirect();
          this.setErrorMessage(e);
          console.error(e);
        },
        complete: () => console.info('getCustomerPreference complete')
      });
    } else {
      if (this.enablePlansV3) {
        this.analyticsFirstLanding = true;
      }
      this.checkStepRedirect();
    }
    this.fetchPlans();
    this.initialiseTooltipEvents();
  }

  public checkStepRedirect(): void {
    if (this.selectPlanStepRedirect) {
      this.isDeliveryAvailable(this.userInfo?.j4uZipcode || this.userInfo?.j4u?.zipcode || '');
    } else {
      this.setDefault();
    }
  }

  // --------------------------------------------------------------------------
  /**
   * This is will get customer type, regular customer or employee
   *
   */
  // --------------------------------------------------------------------------
  public getCustomerType(): Observable<any> {
    return this.subscriptionService.getCustomerType().pipe(map((data) => {
      if (data) {
        return (data.profile.customerType?.toUpperCase() === 'E') ? true : false;
      } else {
        console.error('Message: Customer Profile missing.');
      }
    }));
  }
  // --------------------------------------------------------------------------
  /**
   * This is will get plans and share the observable so that we can cache list of plans in the page
   *
   */
  // --------------------------------------------------------------------------
  getPlans() {
    this.getDiscountCode();

    if (!this.plans$) {
      this.plans$ = this.subscriptionService.getPlans(this.promoDiscountCode, this.userInfo).pipe(shareReplay(1));
    }
    return this.plans$;
  }

  getDiscountCode() {
    const params = this.windowUtil.getWindowSearchParams();
    const discountCode = params.get(this.programDisplayData?.promotionKeys?.discountCode);
    const segment = params.get(this.programDisplayData?.promotionKeys?.segment);
    
    let promoDiscountCodeObj = {};

    if (segment) {
      promoDiscountCodeObj[this.programDisplayData?.promotionKeys?.segment] = segment;
    } 
    if (discountCode) {
      promoDiscountCodeObj[this.programDisplayData?.promotionKeys?.discountCode] = discountCode;
    }

    this.promoDiscountCode = promoDiscountCodeObj;
  }

  // --------------------------------------------------------------------------
  /**
   * This will fetch plan details and update zipcode description string with current plan prices
   */
  // --------------------------------------------------------------------------
  fetchPlans() {
    this.showLoader();
    this.isPlansLoading = true;

    setTimeout(() => {
      this.getPlans().subscribe({
        next: (data: any) => {
          if (data) {
            let discountError = data.Data?.error;
            let campaignOptions = {};

            let plansInfo: any = {
              discountedTargetUser: false,
              hasDiscountedAnnualPlan: false,
              hasDiscountedMonthlyPlan: false
            };

            this.availablePlans = (data.Data.subscriptions.length > 0 && data.Data.subscriptions) ? data.Data.subscriptions : [];
            if (this.enableSnap) {
              this.availablePromoPlans = (data.Data.promotionPlans) ? data.Data.promotionPlans : [];
              this.checkBannerSnapEligibility();
            }
            if (this.availablePlans.length === 1) {
              this.setOnePlanCampaign(this.availablePlans);
            }

            this.zipDescription = 'Just {annual-plan-price}{conjunction}{monthly-plan-price}{extended-trial}.';
            this.availablePlans.forEach(plan => {
              const planName = plan.caption.replace(/\s/g, '').toLowerCase();
              let price = plan.pricingDetailLine1.replace(/[\(\)']+/g, '');
              this.employeeDiscountMessage = 'NA';

              if (this.enableSnap && plan.isSheerVerified) {
                this.isSnapVerified = true;
              }

              if (this.enablePlansV3) {
                this.regularTrialDuration = plan.regularTrialDuration;

                // If the plan has an extended trial, store the duration.
                if (plan.isExtendedTrialDuration) {
                  this.extendedTrialDuration = plan.trialDuration;
                  this.isExtendedTrial = true;
                }
              }

              if (plan?.campaignRules) {
                campaignOptions["campaignRules"] = plan.campaignRules;
              }
              if (plan?.campaignTitle) {
                campaignOptions["campaignTitle"] = plan.campaignTitle;
              }

              if (planName.includes('annualplan')) {
                this.isAnnualDiscountedPrice = plan.isDiscountedPrice;
                this.annualDiscountDuration = plan.discountDuration;
                this.analyticsAnnualPrice = plan.planPrice;
                this.analyticsCampaignType = plan.campaignType;
                const annualPrice = this.isAnnualDiscountedPrice ? `<s><span class="sr-only">Original Price</span>$${plan.regularPlanPrice}</s>` + ' ' + `<span class="employee-discount"><span class="sr-only">Discount Price</span>${price}</span>` : price;
                this.zipDescription = (this.isUserEmployee && this.isAnnualDiscountedPrice) ? this.zipDescription?.replace('{annual-plan-price}', annualPrice) : this.zipDescription?.replace('{annual-plan-price}', price);

                this.zipDescriptionSrLabel =this.zipDescription
                .replace(/<[^>]*>?/gm, '') // Remove HTML tags
                .replace(/\/year/g, ' per year') // Replace "/year" with " per year"
                .replace(/\/month/g, ' per month'); // Replace "/month" with " per month"

                if (this.enablePlansV3) {
                  if (plan.isDiscountedPrice) {
                    plansInfo.hasDiscountedAnnualPlan = true;
                    plansInfo.discountedTargetUser = true;
                  }

                  if (plan.signUpBeforeDate)
                    this.signUpBeforeDate = plan.signUpBeforeDate;

                  // Gather the relevant annual plan information which will be used
                  // to generate the landing page messages once all the plans have
                  // been gathered
                  plansInfo['annualplan'] = {
                    caption: plan.caption,
                    planPrice: plan.planPrice,
                    planPriceDetail: plan.planPriceDetail,
                    regularPlanPrice: plan.regularPlanPrice,
                    pricingDetailLine1: plan.pricingDetailLine1,
                    iSSNAPVerified: plan.promoCategory === "SNAP",
                  };
                }
              } else if (planName.includes('monthlyplan')) {
                this.isMonthlyDiscountedPrice = plan.isDiscountedPrice;
                this.monthlyDiscountDuration = plan.discountDuration;

                this.analyticsMonthlyPrice = plan.planPrice;
                this.analyticsCampaignType = plan.campaignType;
                let monthlyPrice = this.isMonthlyDiscountedPrice ? `<s><span class="sr-only">Original Price</span>$${plan.regularPlanPrice}</s>` + ' ' + `<span class="employee-discount"><span class="sr-only">Discount Price</span>${price}</span>` : price;
                this.zipDescription = (this.isUserEmployee && this.isMonthlyDiscountedPrice) ? this.zipDescription?.replace('{monthly-plan-price}', monthlyPrice) : this.zipDescription?.replace('{monthly-plan-price}', price);
                this.zipDescriptionSrLabel =this.zipDescription
                .replace(/<[^>]*>?/gm, '') // Remove HTML tags
                .replace(/\/year/g, ' per year') // Replace "/year" with " per year"
                .replace(/\/month/g, ' per month'); // Replace "/month" with " per month"

                if (this.enablePlansV3) {
                  if (plan.isDiscountedPrice) {
                    plansInfo.hasDiscountedMonthlyPlan = true;
                    plansInfo.discountedTargetUser = true;
                  }

                  if (plan.signUpBeforeDate)
                    this.signUpBeforeDate = plan.signUpBeforeDate;

                  // Gather the relevant monthly plan information which will be used
                  // to generate the landing page messages once all the plans have
                  // been gathered
                  plansInfo["monthlyplan"] = {
                    caption: plan.caption,
                    planPrice: plan.planPrice,
                    planPriceDetail: plan.planPriceDetail,
                    regularPlanPrice: plan.regularPlanPrice,
                    pricingDetailLine1: plan.pricingDetailLine1,
                    iSSNAPVerified: plan.promoCategory === "SNAP",
                  };
                }
              }
            });
            if (!($.isEmptyObject(campaignOptions))) {
              this.setCampaignOptions(campaignOptions);
            }
            if (this.enablePlansV3) {
              this.setSubscriptionLanding(plansInfo);
            }
            if (discountError) {
              this.promoDiscountCode = null;
              if (this.step === this.SUBSCRIPTION_LANDING) {
                this.displayErrorModal(discountError);
              }
            }
          } else {
            this.setErrorMessage();
          }
        },
        complete: () => {
          this.hideLoader();
          this.isPlansLoading = false;
        },
        error: (e) => {
          this.setErrorMessage(e);
          console.error(e);
        }
      });
    }, 1000);
  }

  // --------------------------------------------------------------------------
  /**
   * Check if user is signed in and free trial is available
   * just return true or false if the user is eligible or not
   */
  // --------------------------------------------------------------------------
  public checkBannerSnapEligibility() {
    const SNAPPlan = this.availablePromoPlans.find((plan) => plan.planName === this.programDisplayData?.planCard?.SNAP);
    if (SNAPPlan && SNAPPlan.planDetails.verificationStatus === this.programDisplayData?.planCard?.snapNotVerified) {
      this.isSnapEligibleForBanner = true;
    } else {
      this.isSnapEligibleForBanner = false;
    }
  }
  public getCustomerPreference(): Observable<any> {
    const customerPreferencesObj = {
      'freeTrial': true,
      'subscription': false,
      'subscriptionType': null,
    };

    return this.getPlans().pipe(map(data => {
      if (data) {
        this.availablePlans = (data.Data.subscriptions.length > 0 && data.Data.subscriptions) ? data.Data.subscriptions : [];
        if (this.enableSnap) {
          this.availablePromoPlans = (data.Data.promotionPlans && data.Data.promotionPlans.length > 0) ? data.Data.promotionPlans : [];
          this.checkBannerSnapEligibility();
        }
        const isPlanselected = [];
        const isExtendedTrial = [];

        // Replace jQuery each with native forEach
        this.availablePlans.forEach(plan => {
          isPlanselected.push(plan.selected);
          if (plan.selected) {
            customerPreferencesObj.subscriptionType = plan.caption;
          }
          isExtendedTrial.push(plan.isExtendedTrialDuration);
        });
        
        if (isPlanselected.indexOf(true) !== -1) {
          customerPreferencesObj.subscription = true;
          customerPreferencesObj.freeTrial = false;
        } else if (data.Data.returningCustomer === true && isExtendedTrial.indexOf(true) !== -1) {
          customerPreferencesObj.freeTrial = true;
        } else if (data.Data.returningCustomer === true) {
          customerPreferencesObj.freeTrial = false;
        }
        return customerPreferencesObj;
      } else {
        this.setErrorMessage();
      }
    }));
  }

  // --------------------------------------------------------------------------
  /**
   * Resets inline error message on focus
   */
  // --------------------------------------------------------------------------
  public resetValues() {
    this.displayErrorMessage = '';
    this.cvvErrorMessage = '';
  }

  // --------------------------------------------------------------------------
  /**
   * Redirect to Fresh Pass Sister Banner with parameters for session update
   * @param storeId
   * @param userPref
   * @param zipcode
   */
  // --------------------------------------------------------------------------
  public redirectFPSisterBanner(storeId, userPref, zipcode) {
    let bannerDomainKeyMap = 'www-' + this.deliveryBanner;
    let b2bBannerDomainKeyMap = 'www-business-' + this.deliveryBanner;
    let bannerDomain = window['SWY']['CONFIGSERVICE'].bannerDomainMap[bannerDomainKeyMap];

    //update banner domain IF on B2B and b2b sisterbanner is available
    if (this.isB2B && this.b2BSisterBannerIsAvailable) {
      bannerDomain = window['SWY']['CONFIGSERVICE'].bannerDomainMap[b2bBannerDomainKeyMap];
    }

    const pathName = window.location.pathname;
    const parameters = '?storeId=' + storeId + '&preference=' + userPref + '&zipcode=' + zipcode;

    let queryString = this.windowUtil.getWindowLocationSearch();
    if (queryString.includes('?discountCode=') || queryString.includes('?segment='))
      queryString = queryString.replace('?', '&');

    this.windowUtil.setWindowLocationHref(bannerDomain + pathName + parameters + queryString);
  }

  // --------------------------------------------------------------------------
  /**
   * Checks if express store and updates tile to 2 hour delivery.
   */
  // --------------------------------------------------------------------------
  public checkTwoHourDelivery() {
    let unlimitedDeliverySelector = $("[data-type='delivery'] .unlimited-free-delivery");
    let twoHoursSelector = $("[data-type='delivery'] .two-hours-delivery");
    let isExpressStore = localStorage.getItem('isExpressStore');
    if (isExpressStore === 'true') {
      twoHoursSelector.removeClass('d-none');
      unlimitedDeliverySelector.addClass('d-none');
    } else {
      twoHoursSelector.addClass('d-none');
      unlimitedDeliverySelector.removeClass('d-none');
    }
  }

  // --------------------------------------------------------------------------
  /**
   * Zipcode Validation if Intent is not Delivery
   */
  // --------------------------------------------------------------------------
  public isDeliveryAvailable(zipcode: string) {
    // validate zipcode
    const zipcodeValidationResponse = this.zipcodeService.validateZipcode(zipcode);
    this.resetValues();
    if (zipcodeValidationResponse.validZipcode && !this.isRestrictedZipcode(zipcode)) {
      const storeResolverEndpointParam = window['AB'].storeResolverZipcodeToShoppingEndpoint || this.properties.storeResolverZipcodeToShoppingEndPoint;
      // tslint:disable-next-line: label-position
      // tslint:disable-next-line: max-line-length
      this.setCTARegistrationButtonsDisplay(true);
      //Pass banner parameter only if flag for Fresh Pass is disabled
      this.subscriptionService.getStores(storeResolverEndpointParam, this.subscriptionService.APIParams(zipcode))
        .subscribe({
          next: (data) => {
            if (data) {
              let tileSelector = null;
              tileSelector = $("[data-type='delivery']").parent();
              let availability = data['availability'];
              this.storeId = availability['delivery'].storeId;
              this.deliveryBanner = availability['delivery'].banner;
              if (this.isB2B) {
                let b2bBannerDomainKeyMap = 'www-business-' + this.deliveryBanner;
                this.b2BSisterBannerIsAvailable = window['SWY']['CONFIGSERVICE'].bannerDomainMap[b2bBannerDomainKeyMap] ? true : false;
                if (this.b2BSisterBannerIsAvailable) {
                  this.setDeliveryBannerProps();
                }
              }
              localStorage.setItem('isExpressStore', availability['delivery']['isExpressStore']);
              localStorage.setItem('isStoreDeliveryAvailable', availability['delivery']['available']);
              // Check if delivery is available
              if (availability['delivery'].available) {
                // show 'free delivery' tile when delivery available
                tileSelector.removeClass('d-none');
                
                this.landingUser.currentZipcode = zipcode;
                if (this.enableFPSisterBanner && this.deliveryBanner !== this.currentBanner) {
                  this.landingUser.isStoreDeliveryAvailable = false;
                  this.isSisterBannerAvailable = true;
                  setTimeout(() => {
                    this.focusOnBackButton();
                  }, 0);
                  return;
                }
                // if Guest user update session else display plans step.
                (this.landingUser.isAuthorized === false && this.currentBanner === this.deliveryBanner) ? this.updateUserSession(zipcode) : this.checkIsDefaultPlan();
                this.landingUser.isStoreDeliveryAvailable = true;
                this.isStorePickupOnlyAvailable = false;
              } else {
                // hide 'free delivery' tile when delivery not available
                tileSelector.addClass('d-none');
                // if only pickup is available display plans step and show unavailable message
                if (availability['pickup'].available) {
                  this.isStorePickupOnlyAvailable = true;
                  this.checkIsDefaultPlan();
                  this.landingUser.currentZipcode = zipcode;
                } else {
                  //if delivery and pickup unavailable show apologies screen
                  this.landingUser.isStoreDeliveryAvailable = false;
                  this.updateAnalytics('service-unavailable');
                }
                window.scroll({ top: 0 });
              }
            }
          },
          error: (e) => {
            this.setErrorMessage(e);
            console.error(e);
          },
          complete: () => console.info('getStores complete')
        });
    } else {
      this.displayErrorMessage = zipcodeValidationResponse.message;
    }
  }

  public setDeliveryBannerProps() {
    this.deliveryBannerPrefix = 'Business.'
    this.deliveryBannerSuffix = '_b2b';
  }

  // --------------------------------------------------------------------------
  /**
   * Back button behavior
   */
  // --------------------------------------------------------------------------
  public backButtonClicked() {
    this.setCTARegistrationButtonsDisplay(false);
    this.landingUser.isStoreDeliveryAvailable = true;
    this.isZipcodeRestricted = false;
    this.isStorePickupOnlyAvailable = false;
    this.isSisterBannerAvailable = false;
    this.setStep(this.SUBSCRIPTION_LANDING);
  }

  // --------------------------------------------------------------------------
  /**
   * Sets Active step
   * @param step    sets active step based on parameter passed
   * @param displayZipcodeField    displays zipcode text field if value is true
   */
  // --------------------------------------------------------------------------
  public setStep(step: any, displayZipcodeField?: boolean) {
    // reset error messages before setting step.
    this.resetValues();
    this.showZipcodeField = displayZipcodeField ? displayZipcodeField : false;
    this.changeZip = (this.step === this.SELECT_PLAN) ? this.showZipcodeField : false;
    if (this.showZipcodeField) {
      this.setCTARegistrationButtonsDisplay(false);
    }
    this.step = step;
    this.updateHeaderVisibility();
    // scroll to top on changing step
    window.scroll({ top: 0 });
  }

  updateHeaderVisibility() {
    if (this.enableForUPlus) {
      if (this.step === this.SELECT_PLAN) {
        const headerElement = document.querySelector('.unified-header-v3');
        if (headerElement) {
          this.renderer.addClass(headerElement, 'hidden');
        }
      } else {
        const headerElement = document.querySelector('.unified-header-v3');
        if (headerElement) {
          this.renderer.removeClass(headerElement, 'hidden');
        }
      }
    }
  }

  // --------------------------------------------------------------------------
  /**
   *Checks if zipcode is on list of restricted zipcodes
   returns true if zipcode is restricted
   *@param zipcode checks zipcode passed if any, from zipcode solicitation
   otherwise takes session zipcode
   */
  // --------------------------------------------------------------------------
  public isRestrictedZipcode(zipcode?: string) {
    const zip = zipcode ? zipcode : this.landingUser.currentZipcode;
    this.isZipcodeRestricted = this.restrictedZipcodesList.indexOf(zip) > -1;
    if (zipcode && this.isZipcodeRestricted) {
      this.landingUser.isStoreDeliveryAvailable = false;
    }
    return this.isZipcodeRestricted;
  }

  // --------------------------------------------------------------------------
  /**
   * Checks default plan and returns appropriate authored ribbon label
   */
  // --------------------------------------------------------------------------
  public checkIsDefaultPlan() {
    if (this.annualPlanIsDefaultPlan === 'true') {
      this.apDefault = true;
      this.ribbonLabel = this.annualPlanDefaultRibbon;
    } else {
      this.apDefault = false;
      this.ribbonLabel = this.monthlyPlanDefaultRibbon;
    }

    // display available subscription plans. If one plan, skip available plans display
    if (this.isOnePlanCampaign && this.availablePlans?.length === 1) {
      this.setPlanChangeStep(0);
    } else {
      this.displayAvailablePlans();
    }
    this.setCTARegistrationButtonsDisplay(true);
  }

  // --------------------------------------------------------------------------
  /**
   * Set selected plan type
   */
  // --------------------------------------------------------------------------
  public setPlanType(planType: string) {
    this.planType = planType;
  }

  // --------------------------------------------------------------------------
  /**
   * Set plan and change step
   */
  // --------------------------------------------------------------------------
  public setPlanChangeStep(planID: any) {
    if (this.enableSnap && (this.availablePlansHTML[planID].title.includes("SNAP") || this.availablePlansHTML[planID].title.includes("Gov"))) {
      this.router.navigate([this.programDisplayData?.urlPath?.GOV_ASSIST_PATH]);
      return;
    } else {
      this.setSelectedPlan(planID);
      if (!this.isUserAuthorized()) {
        this.updateAnalytics("step2", this.planType, this.landingUser?.isEligibleForFreeTrial);
        this.persistPlanInfo(this.MODE_CREATE_ACCOUNT);
        this.setStep(this.SIGN_IN);
        this.windowUtil.setWindowLocationHref("/account/sign-in.html");
      } else {
        this.displayPaymentDetails();
      }
    }
  }

  // --------------------------------------------------------------------------
  /**
   * Set selected plan object to be persisted until Payment page
   */
  // --------------------------------------------------------------------------
  public setSelectedPlan(planID) {
    let planType = "";
    this.selectedPlan = this.availablePlans[planID];
    if (this.availablePlansHTML[planID].title.includes("Gov")) {
      planType = this.selectedPlan.title ? this.selectedPlan.title.replace(/\s/g, "").toLowerCase() : "";
    } else {
      planType = this.selectedPlan.caption ? this.selectedPlan.caption.replace(/\s/g, "").toLowerCase() : "";
    }
    this.setPlanType(planType);
  }

  // ------------------------------------------------------------------------------------------------------------
  /**
   * Maps a the Subscription Plans list received from API to a new list to be displayed in HTML
   */
  // ------------------------------------------------------------------------------------------------------------
  public mapAvailablePlans(subscriptionPlans: any) {
    this.availablePlansHTML.splice(0, this.availablePlansHTML.length);
    if (subscriptionPlans && subscriptionPlans.length > 0) {
      subscriptionPlans.forEach(plan => {
        this.availablePlansHTML.push(this.enableSnap ? this.mapCardPlans(plan) : this.mapPlan(plan));
      });
      //This is var is set for the case where only available plans will be displayed on payments plan selection screen
      this.availablePaymentPlans = this.availablePlansHTML;
    }
    const snapPromotionPlans = this.availablePromoPlans?.find((plan) => plan.planName === this.programDisplayData?.planCard?.SNAP);
    if (snapPromotionPlans?.planDetails?.verificationStatus === this.programDisplayData?.planCard?.snapNotVerified) {
      this.availablePlansHTML.push(this.enableSnap ? this.mapCardPlans(snapPromotionPlans.planDetails, this.programDisplayData?.planCard?.SNAP) : this.mapPromoPlans(this.availablePromoPlans.SNAP));
    }
  }

  public mapCardPlans(plan: any, key?: string) {
    let planName = "";
    if (plan?.caption) {
      planName = plan.caption.replace(/\s/g, "").toLowerCase();
    }
    if (plan?.title) {
      planName = plan.title.replace(/\s/g, "").toLowerCase();
    }

    const annualPlanCard: PlanCard = {
      title: plan.caption,
      action: this.programDisplayData?.planCard?.selectAction,
      banner: plan.pricingDetailLine1,
      bannerAnouncement: convertCurrencyToWords(plan.pricingDetailLine1),
      subBanner: "",
      subBannerAnouncement: "",
      benefits: !this.enableForUPlus ? [
        {
          icon: this.programDisplayData?.planCard?.creditIcon,
          label: this.programDisplayData?.planCard?.annualCreditLabel,
        },
      ] : [],
      label: plan.monthlySavingsPercent,
      details: {
        cost: plan.pricingDetailLine1,
        planName: "",
        isPromo: false,
        innerHtmlCost: "",
        isDefaultPlan: false,
        hasDiscountPriceAvailable: plan.planPrice !== plan.regularPlanPrice,
      },
    };

    const monthlyPlanCard: PlanCard = {
      title: plan.caption,
      action: this.programDisplayData?.planCard?.selectAction,
      banner: plan.pricingDetailLine1,
      bannerAnouncement: convertCurrencyToWords(plan.pricingDetailLine1),
      subBanner: "",
      subBannerAnouncement: "",
      benefits: [
      ],
      label: "",
      details: {
        cost: plan.pricingDetailLine1,
        planName: "",
        isPromo: false,
        innerHtmlCost: "",
        isDefaultPlan: false,
        hasDiscountPriceAvailable: plan.planPrice !== plan.regularPlanPrice,
      },
    };

    const snapPlanCard: PlanCard = {
      title: plan.title,
      action: plan.verificationDisplayText,
      banner: plan.discountText,
      subBanner: this.programDisplayData?.planCard?.SNAPPlanDescription,
      benefits: [
        {
          icon: this.programDisplayData?.planCard?.greenIcon,
          label: this.programDisplayData?.planCard?.trialLabel,
        }
      ],
      label: "",
      details: {
        cost: "",
        planName: "",
        isPromo: true,
      },
    };

    const freetrialAvailableContent = {
      icon: this.programDisplayData?.planCard?.greenIcon,
      label: plan.trialDuration + this.programDisplayData?.planCard?.trialLabel,
    };

    const snapFreeTrialAvailableContent = {
      icon: this.programDisplayData?.planCard?.greenIcon,
      label: this.programDisplayData?.planCard?.trialLabel,
    };
    
    //checks if user is eligibile for free trial, if they are add freetrial message to plans card
    if (this.landingUser.isEligibleForFreeTrial && plan?.trialDuration > 0) { 
      annualPlanCard.benefits.unshift(freetrialAvailableContent);
      monthlyPlanCard.benefits.unshift(freetrialAvailableContent);
    }


    if (planName === 'annualplan') {
      if (plan.promoCategory === "SNAP") {
        annualPlanCard.banner = `$${plan.planPrice} <s class="strick">$${plan.regularPlanPrice}</s> ${plan.planPriceDetail}`;
        annualPlanCard.subBanner = this.programDisplayData?.planCard?.AnnualDescriptionForSNAPVerified;
      }
      else {
        if (this.annualPlanDescription) {
          annualPlanCard.subBanner = this.annualPlanDescription.replace("{price}", plan.pricingDetailLine2.replace(/[\(\)']+/g, ""));
          annualPlanCard.subBannerAnouncement = convertCurrencyToWords(annualPlanCard.subBanner);
        }
        if (plan.isDiscountedPrice && this.enablePlansV3) {
          annualPlanCard.subBanner = annualPlanCard.subBanner.replace("{renewPrice}", " at $" + plan.regularPlanPrice.replace(/[\(\)']+/g, "") + "/year");
          annualPlanCard.subBannerAnouncement = convertCurrencyToWords(annualPlanCard.subBanner);
        } else {
          annualPlanCard.subBanner = annualPlanCard.subBanner.replace("{renewPrice}", " $" + plan.pricingDetailLine1.replace(/[\(\)']+/g, ""));
          annualPlanCard.subBannerAnouncement = convertCurrencyToWords(annualPlanCard.subBanner);
        }
      }
      if (plan?.caption) {
        planName = plan.caption.replace(/\s/g, "").toLowerCase();
      }
      annualPlanCard.details.planName = planName;
      annualPlanCard.details.isDefaultPlan = this.apDefault ? true : false;
      return annualPlanCard;
    } else if (planName === 'monthlyplan') {
      if (plan.promoCategory === "SNAP") {
        monthlyPlanCard.banner = `$${plan.planPrice} <s class="strick">$${plan.regularPlanPrice}</s>${plan.planPriceDetail}`;
        monthlyPlanCard.subBanner = this.programDisplayData?.planCard?.monthlyDescriptionForSNAPVerified?.replace("{price}", plan.pricingDetailLine1.replace(/[\(\)']+/g, ""));
      }
      else {
        monthlyPlanCard.subBanner = this.monthlyPlanDescription2;
        monthlyPlanCard.subBannerAnouncement = convertCurrencyToWords(monthlyPlanCard.subBanner);
        if (plan.isDiscountedPrice) {
          let monthlyPrice = ` at $${plan?.regularPlanPrice}/mo after ${plan?.discountDuration} months`;
          monthlyPlanCard.subBanner = this.monthlyPlanDescription2 ? this.monthlyPlanDescription2.replace("{price}", monthlyPrice) : "";
          monthlyPlanCard.subBannerAnouncement = convertCurrencyToWords(monthlyPlanCard.subBanner);
        } else {
          monthlyPlanCard.subBanner = this.monthlyPlanDescription2 ? this.monthlyPlanDescription2.replace("{price}", plan.pricingDetailLine1.replace(/[\(\)']+/g, "")) : "";
          monthlyPlanCard.subBannerAnouncement = convertCurrencyToWords(monthlyPlanCard.subBanner);
        }
      }
      if (plan?.caption) {
        planName = plan.caption.replace(/\s/g, "").toLowerCase();
      }
      monthlyPlanCard.details.planName = planName;
      monthlyPlanCard.details.isDefaultPlan = this.apDefault ? false : true;
      return monthlyPlanCard;
    } else if (key === 'SNAP') {
      snapPlanCard.title = plan.title + " " + "Plans";
      if (plan?.discountedPrice && plan?.planPriceDetail) {
        snapPlanCard.details.cost = `$${plan.discountedPrice}${plan.planPriceDetail}`;
      }
      if (plan?.title) {
        planName = plan.title.replace(/\s/g, "").toLowerCase();
      }
      
      const promotionTrialDuration = plan?.availablePlans[0]?.trialDuration;
      const snapFreeTrialLabel = snapPlanCard?.benefits?.[0]?.label
      if (this.landingUser.isEligibleForFreeTrial && snapFreeTrialLabel && promotionTrialDuration) {
        snapPlanCard.benefits[0].label = `${promotionTrialDuration}${this.programDisplayData?.planCard?.trialLabel}`;
      } else {
        snapPlanCard.benefits = {};
      }
      
      if (snapPlanCard?.details?.planName)
        snapPlanCard.details.planName = planName;

      return snapPlanCard;
    }
  }

  // ------------------------------------------------------------------------------------------------------------
  /**
   * Maps a plan object received from API to a plan that is displayed in HTML with fields from AEM
   *
   * @param plan a Subscription Plan Object
   *
   * @return plan object with fields from AEM to be displayed in HTML
   */
  // ------------------------------------------------------------------------------------------------------------
  public mapPlan(plan) {
    // @ts-ignore
    const planHTML = {
      title: '',
      description: '',
      cost: '',
      innerHtmlCost: '',
      isDefaultPlan: false,
      planName: '',
      hasDiscountPriceAvailable: false,
      trialDuration: '',
      isPromo: false,
      promoCategory: '',
    };

    // remove spaces and convert to caption to lowercase to use in HTML
    let planName = "";
    if (plan?.caption || plan?.title) {
      planName = plan.caption.replace(/\s/g, '').toLowerCase();
    }

    planHTML.title = plan.caption;
    planHTML.cost = plan.pricingDetailLine1;
    planHTML.planName = planName;
    planHTML.hasDiscountPriceAvailable = plan.planPrice !== plan.regularPlanPrice;
    planHTML.trialDuration = plan.trialDuration + '';
    if (planName === 'annualplan') {
      // replace {price} from authoring field with API  price detail 2
      if (this.annualPlanDescription) {
        planHTML.description = this.annualPlanDescription.replace('{price}', plan.pricingDetailLine2.replace(/[\(\)']+/g, ''));
      }
      if (plan.isDiscountedPrice && this.enablePlansV3) {
        planHTML.description = planHTML.description.replace('{renewPrice}', ' at $' + plan.regularPlanPrice.replace(/[\(\)']+/g, '') + '/year');
      } else {
        planHTML.description = planHTML.description.replace('{renewPrice}', '');
      }
      planHTML.isDefaultPlan = this.apDefault ? true : false;
    } else if (planName === 'monthlyplan') {

      if (plan.isDiscountedPrice) {
        let monthlyPrice = ` at $${plan?.regularPlanPrice}/mo after ${plan?.discountDuration} months`;
        planHTML.description = this.monthlyPlanDescription ? this.monthlyPlanDescription.replace('{price}', monthlyPrice) : "";
      } else {
        planHTML.description = this.monthlyPlanDescription ? this.monthlyPlanDescription.replace('{price}', '') : "";
      }
      planHTML.isDefaultPlan = this.apDefault ? false : true;
    } else if (planName.includes('snap')) {
      planHTML.innerHtmlCost = `<span><span class="sr-only">Discount Price</span>$${plan.monthlyCost}</span> <s><span class="sr-only">Original Price</span>$${plan.regularPlanPrice}</s>/month`;
      planHTML.cost = `$${plan.monthlyCost}/month`;
      planHTML.description = this.snapMonthlyPlanDescriptionSpacing
    }
    return planHTML;
  }

  // ------------------------------------------------------------------------------------------------------------
  /**
   * Maps a plan object received from API to a plan that is displayed in HTML with fields from AEM
   *
   * @param plan a Promotion subscription Plan Object
   *
   * @return plan object with fields from AEM to be displayed in HTML
   */
  // ------------------------------------------------------------------------------------------------------------
  public mapPromoPlans(plan) {
    const planHTML = {
      title: '',
      description: '',
      cost: '',
      isDefaultPlan: false,
      planName: '',
      hasDiscountPriceAvailable: false,
      trialDuration: '',
      isPromo: true,
      promoCategory: ''
    };

    // remove spaces and convert to caption to lowercase to use in HTML
    let planName = "";
    if (plan?.promoTitle) {
      planName = plan.promoTitle.replace(/\s/g, '').toLowerCase();
      planHTML.title = plan.promoTitle;
    }

    planHTML.planName = planName;
    if (plan?.discountedPrice && plan?.planPriceDetail) {
      planHTML.cost = `$${plan.discountedPrice}${plan.planPriceDetail}`
    }
    if (plan.promoCategory && plan.promoCategory.toLowerCase().includes('snap')) {
      //# of plans to display different plan Description
      planHTML.promoCategory = plan.promoCategory;
      const promoPlanNum = 3;
      if (this.availablePromoPlans.length >= promoPlanNum) {
        planHTML.description = this.snapMonthlyPlanDescription;
      } else {
        planHTML.description = this.snapMonthlyPlanDescriptionSpacing;
      }
    }

    return planHTML;
  }

  // --------------------------------------------------------------------------
  /**
   * Set setupAccount Step
   */
  // --------------------------------------------------------------------------
  public setAccountSetupStep() {
    this.setStep(this.SIGN_UP);
    let that = this;
    setTimeout(function () {
      let accountSetup = $('.srAccountSetup');
      let signInSection = $('.srSignIn');
      signInSection.addClass('d-none');
      $('#setUpAccount').append(accountSetup);
      accountSetup.css('visibility', 'visible');
      accountSetup.removeClass('d-none');
      that.persistPlanInfo(that.MODE_CREATE_ACCOUNT);
    }, 10);
    $('.srAccountSetup .uca-form-submit-btn-signin').on('click', function (event) {
      event.preventDefault();
      that.setStep(that.SIGN_IN);
      that.srTriggerSignIn();
      that.analyticsNextStep = 'sign_in';
      if (that.analyticsCurrentStep !== that.analyticsNextStep) {
        that.updateAnalytics('step2', that.planType, that.landingUser?.isEligibleForFreeTrial);
        that.analyticsCurrentStep = 'sign_in';
      }
    });
  }

  // --------------------------------------------------------------------------
  /**
   * Trigger SignIn section
   */
  // --------------------------------------------------------------------------
  public srTriggerSignIn() {
    this.setStep(this.SIGN_IN);
    const $this = this;
    // set current page path in ECommRedirectURL cookie to land after sign in

    this.setEcommRedirectURLCookie();

    setTimeout(function () {
      let accountSetup = $('.srAccountSetup');
      let signInSection = $('.srSignIn');
      $(window).scrollTop(0);
      $(accountSetup).addClass('d-none');
      signInSection.removeClass('d-none');
      $this.removePersistedInfo();
      $('#setUpAccount').append(signInSection);
    }, 10);
    $('.srSignIn .btn-create-account').on('click', (event) => {
      event.preventDefault();
      $this.setAccountSetupStep();
      $this.analyticsNextStep = 'sign_up';
      if ($this.analyticsCurrentStep !== $this.analyticsNextStep) {
        $this.updateAnalytics('step2', $this.planType, $this.landingUser?.isEligibleForFreeTrial);
        $this.analyticsCurrentStep = 'sign_up';
      }
    });
  }

  // --------------------------------------------------------------------------
  /**
   * Toggle tc agreement checkbox
   */
  // --------------------------------------------------------------------------
  public tcCheck() {
    this.tc = !this.tc;
  }

  public detectTCModal() {
    const modalIsOpen = $('.modal').hasClass('show');
    if (!modalIsOpen) {
      this.authService.checkIfValidSWYUserInfo()
        .then(() => {
          this.subscriptionService.getFreshpassTerms(this.userInfo, this.currentEnvironment).subscribe({
            next: (data) => {
              if (data && data.content) {
                this._freshpassModalService.openModalWithComponent(TermsContentComponent, {
                  initialState: {
                    userInfo: this.userInfo,
                    content: data.content,
                    lastActiveEle: document.activeElement,
                  },
                  class: 'slot-picker-modal',
                  backdrop: 'static',
                  ariaDescribedby: 'slot-msg',
                  ariaLabelledBy: "dialoghead-slot-details",
                });
              }
            },
            error: (e) => console.error(e),
            complete: () => console.info('getFreshpassTerms complete')
          });
        })
        .catch(err => {
          this.authService.redirectToSSO({});
        })
    }
    window['AB']['DATALAYER'].setModalViewEvents('delivery-subscription-terms');
  }

  // --------------------------------------------------------------------------
  /**
   * Makes API call to get tenders and displays the CC information in an iframe
   */
  // --------------------------------------------------------------------------
  public displayPaymentDetails() {
    this.showLoader();
    this.setStep(this.PAYMENT);
    this.changeDetector.detectChanges();
    try {
      this.renderReactComponent()
    } catch {
      this.setErrorMessage()
    } finally {
      this.hideLoader()
    }
    this.updateAnalytics('step3', this.planType, this.landingUser?.isEligibleForFreeTrial);
  }


  // --------------------------------------------------------------------------
  /**
   * Render Wallet Component
   */
  // --------------------------------------------------------------------------
  renderReactComponent() {
    let checkboxEnable = (bool: boolean) => {
      // Based on the bool value (i.e either true/false) this method can be used to enable or disable checkbox
      this.enableCheckbox = bool
    }
    let isCheckboxVisible = (bool: boolean) => {
      // Based on the bool value (i.e either true/false) this method can be used to make the checkbox hidden/visible
      this.displayCheckbox = bool
    }
    let routeToFreshPass = (bool: boolean) => {
      // Based on the bool value (i.e either true/false) this method can be used to send event to freshpass for routing back to freshpass
    }
    let openPopUp = (event) => {
      this.detectTCModal();
    }
    let routeToDashboard = (bool: boolean) => {
      if (bool) {
        this.setStep(this.SUBSCRIPTION_LANDING, true)
      }
    }
    this.checkBoxEnable = checkboxEnable;
    this.isCheckBoxVisible = isCheckboxVisible;
    this.openPopup = openPopUp;
    this.routeToDashboard = routeToDashboard;
    ReactDom.render(React.createElement(
      PaymentWallet,
      {
        client: "FreshPass",
        paymentMethodContext: "FRESH_PASS",
        shopToken: this.userInfo?.SWY_SHOP_TOKEN,
        freshPassFlow: "subscription",
        checkboxEnable: checkboxEnable,
        isCheckboxVisible: isCheckboxVisible,
        routeToFreshPass: routeToFreshPass,
        openPopUp: openPopUp,
        routeToDashboard: routeToDashboard,
        ...(this.isB2B && { "customerType": "B" })
      }
    ), document.getElementById("paymentFrame"))
  }

  // --------------------------------------------------------------------------
  /**
   * Displays available Subscription Plans from Step 1
   */
  // --------------------------------------------------------------------------
  public getEnrollmentIdAndCreateSubscription(): void {
    // request post to create subscription.

    let createSubscriptionBody: any = {
      'gid': this.userInfo?.customerId,
      'promotionFee': 25,
      'subscriptionCode': this.selectedPlan?.code,
    };

    if (this.promoDiscountCode && this.promoDiscountCode[this.programDisplayData?.promotionKeys?.discountCode]) {
      createSubscriptionBody[this.programDisplayData?.promotionKeys?.discountCode] = this.promoDiscountCode[this.programDisplayData?.promotionKeys?.discountCode];
    }
    this.showMiniSpinner = true;
    this.subscriptionService.postSubscriptionPlan(this.userInfo, this.selectedPlan?.code, createSubscriptionBody, this.isPrebookReq, this.webSource).subscribe({
      next: (data) => {
        this.showMiniSpinner = false;
        if (data) {
          // format current plan expiry date from 2020-12-22T00:00:00.000Z to July 13, 2021 to display in UI.
          this.renewalDate = window['AB']['COMMON'].formatDate(data.Data.renewalDate);
          // if post call is success and if existing use then update session and send to thank you screen.
          // if (!this.isNewUser && this.landingUser.intent !== 'delivery') {
          //update user session only when intent is delivery and current banner matches delivery banner
          if (this.isPrebookReq && this.isPrebookReq === 'prebook') {
            this.setPrebookLocalStorage();
            this.windowUtil.setWindowLocationHref('/erums/store/prebook');
          } else if (this.webSource?.path) {
            this.windowUtil.setWindowLocationHref(this.webSource.path); 
          } else {
            if (data.Data.status && data.Data.status === "Trial") {
              window['AB']['COMMON'].userNotifyReloadPage(this.programDisplayData?.notificationMsg?.trialEnrollmentSuccessMsg);
            } else {
              window['AB']['COMMON'].userNotifyReloadPage(this.programDisplayData?.notificationMsg?.activeEnrollmentSuccessMsg);
            }
            if (!this.isNewUser && this.landingUser.intent === 'delivery' && this.currentBanner === this.deliveryBanner) {
              this.updateUserSession(this.zipcodeSubscription);
              this.updateAnalytics('confirmation', this.planType, this.landingUser?.isEligibleForFreeTrial);
            } else {
              this.updateAnalytics('nextPageConfirm', this.planType, this.landingUser?.isEligibleForFreeTrial);
                this.windowUtil.setWindowLocationHref(this.programDisplayData?.urlPath?.CONFIRMATION_PATH);
            }
          }
        } else {
          this.setErrorMessage();
        }
      },
      error: (e) => {
        this.setErrorMessage(e);
        console.error(e);
      },
      complete: () => console.info('postSubscriptionPlan complete')
    });
    //remove attributes from local storage.
    localStorage.removeItem("isExpressStore");
    localStorage.removeItem('isStoreDeliveryAvailable');
  }

  // --------------------------------------------------------------------------
  /**
   * Displays available Subscription Plans from Step 1
   */
  // --------------------------------------------------------------------------
  public displayAvailablePlans() {
    if (!this.landingUser.isAuthorized) {
      this.showLoader();
      this.resetValues();
      this.setStep(this.SELECT_PLAN);
      this.getPlans().subscribe({
        next: (data) => {
          if (data) {
            this.hideLoader();
            this.availablePlans = (data.Data.subscriptions.length > 0 && data.Data.subscriptions) ? data.Data.subscriptions : [];
            if (this.enableSnap) {
              this.availablePromoPlans = (data.Data.promotionPlans) ? data.Data.promotionPlans : [];
              this.checkBannerSnapEligibility();
            }
            this.mapAvailablePlans(this.availablePlans);
          } else {
            this.setErrorMessage();
          }
        },
        error: (e) => {
          this.setErrorMessage(e);
          console.error(e);
        },
        complete: () => console.info('getPlans complete')
      });
    } else {
      this.mapAvailablePlans(this.availablePlans);
      this.setStep(this.SELECT_PLAN);
    }
    this.updateAnalytics('step1');
  }

  // --------------------------------------------------------------------------
  /**
   * Check if subscription Local storage available
   * And persist user plan selection.
   */
  // --------------------------------------------------------------------------
  public checkIfSubscriptionLocalStorageExist() {
    let subscriptionLS = localStorage.getItem(this.SUBSCRIPTION_LOCAL_STORAGE);
    if (subscriptionLS) {
      // get subscription local storage
      subscriptionLS = JSON.parse(subscriptionLS);
      if (subscriptionLS[this.USER_SELECTED_PLAN]) {
        // retain available plans
        this.availablePromoPlans = subscriptionLS[this.AVAILABLE_PROMO_PLANS];
        this.mapAvailablePlans(subscriptionLS[this.AVAILABLE_PLANS]);
        this.availablePlans = subscriptionLS[this.AVAILABLE_PLANS];
        // retain user selected plan
        this.selectedPlan = subscriptionLS[this.USER_SELECTED_PLAN];
        const planType = subscriptionLS[this.USER_SELECTED_PLAN_NAME] ? subscriptionLS[this.USER_SELECTED_PLAN_NAME] : '';
        //retain user discountPromo
        this.promoDiscountCode = subscriptionLS[this.DISCOUNT_CODE] ? subscriptionLS[this.DISCOUNT_CODE] : null;
        this.isNewUser = subscriptionLS[this.NEW_USER];

        //retain campaign type
        this.isOnePlanCampaign = subscriptionLS[this.ONE_PLAN_CAMPAIGN];

        //retain partnersPath and partners webSource
        this.webSource.path = subscriptionLS[this.WEBSOURCE_PATH] ? subscriptionLS[this.WEBSOURCE_PATH] : '';
        this.webSource.param = subscriptionLS[this.WEBSOURCE_PARAM] ? subscriptionLS[this.WEBSOURCE_PARAM] : '';

        //get promoPath and append to new url
        const promoPath = subscriptionLS[this.DISCOUNT_CODE_PATH] ? subscriptionLS[this.DISCOUNT_CODE_PATH] : '';

        // remove state param from url.
        window.history.pushState({}, document.title, window.location.pathname + promoPath);
        // remove subscription local storage after retaining
        localStorage.removeItem(this.SUBSCRIPTION_LOCAL_STORAGE);

        this.setPlanType(planType);
        // set payment step as current step
        this.setStep(this.PAYMENT);
        this.setCTARegistrationButtonsDisplay(true);
        this.changeDetector.detectChanges();
        // display payment screen
        this.displayPaymentDetails();
        // if subscription local storage is missing required info then set active step to default(ie, SUBSCRIPTION_LANDING)
      } else {
        this.checkStepRedirect();
      }
    }
    // if subscription local storage is missing set active step to default(ie, SUBSCRIPTION_LANDING)
    else {
      this.checkStepRedirect();
    }
  }

  // --------------------------------------------------------------------------
  /***
   * persists available plans and user selected plan in Local storage
   * Sets ECommRedirectURL cookie to land user on payment page
   * @param modeType  where did user signin from(CreateAccount/signin)
   * */
  // --------------------------------------------------------------------------
  public persistPlanInfo(modeType: string): void {

    // set ECommRedirectURL with current page with payment param.
    this.setEcommRedirectURLCookie()

    window['AB']['COMMON'].setCookie('freshpassState', 'payment');
    if (window['AB']['COMMON'].isLSCompatible()) {
      // add available plans and selected plans to local storage.
      let persistObj = {};
      persistObj[this.NEW_USER] = true;
      persistObj[this.AVAILABLE_PLANS] = this.availablePlans;
      persistObj[this.USER_SELECTED_PLAN] = this.selectedPlan;
      persistObj[this.USER_SELECTED_PLAN_NAME] = this.planType;
      persistObj[this.ONE_PLAN_CAMPAIGN] = this.isOnePlanCampaign;
      persistObj[this.AVAILABLE_PROMO_PLANS] = this.availablePromoPlans;
      persistObj[this.WEBSOURCE_PATH] = this.webSource?.path;
      persistObj[this.WEBSOURCE_PARAM] = this.webSource?.param;

      // if promo path exists, persist to local storage to append to url
      let discountUrl = this.windowUtil.getWindowLocationSearch();
      if (discountUrl?.includes(this.DISCOUNT_CODE)) {
        persistObj[this.DISCOUNT_CODE_PATH] = window.location.search;
      }
      //if discountCode exists, persist to local storage.
      if (this.promoDiscountCode) {
        persistObj[this.DISCOUNT_CODE] = this.promoDiscountCode;
      }
      localStorage.setItem(this.SUBSCRIPTION_LOCAL_STORAGE, JSON.stringify(persistObj));
    }
  }

  // --------------------------------------------------------------------------
  /***
   * Deletes subscription local storage
   *
   * */
  // --------------------------------------------------------------------------
  public removePersistedInfo(): void {
    localStorage.removeItem(this.SUBSCRIPTION_LOCAL_STORAGE);
  }

  // --------------------------------------------------------------------------
  /***
   * sets to default set i.e subscription landing screen.
   * removes state param from url if exist.
   * */
  // --------------------------------------------------------------------------
  public setDefault(): void {
    this.setStep(this.SUBSCRIPTION_LANDING);
    if (this.analyticsCurrentStep !== this.analyticsNextStep && this.analyticsFirstLanding !== true) {
      this.updateAnalytics('landing');
    }
  }

  // --------------------------------------------------------------------------
  /**
   * Updates the user session to DELIVERY
   */
  // --------------------------------------------------------------------------
  public updateUserSession(zipcode?: string) {
    const userType = this.userInfo.userType;
    const deliveryBanner = this.currentBanner;
    const $this = this;

    window['SWY']['ENFORCEMENT'].generateSessionUpdateObject('DELIVERY', this.storeId, zipcode, userType, 'user', deliveryBanner, function (sessionObj) {
      if ($this.landingUser.isAuthorized) {
        // call common method for updating Signed In user
        window['AB']['COMMON'].updateUserSession(sessionObj, null, function (updateResp) {
          if (updateResp.success === true) {
            this.windowUtil.setWindowLocationHref(this.programDisplayData?.urlPath?.CONFIRMATION_PATH);
          }
        });
      } else {
        // call common method for updating guest session
        window['AB']['COMMON'].updateUserSession(sessionObj);
        window['AB'].userInfo.prepareSharedInfo();
        // set default plan
        $this.checkIsDefaultPlan();
      }
    });
  }

  // --------------------------------------------------------------------------
  /**
   * Sets error message for UI to display
   */
  // --------------------------------------------------------------------------
  public setErrorMessage(error?: any): void {
    this.hideLoader();
    this.showMiniSpinner = false;
    this.displayErrorMessage = this.getDisplayMessageError(error?.errorCode);
    this.setCTARegistrationButtonsDisplay(false);
  }

  public setCTARegistrationButtonsDisplay(hide?: boolean): void {
    for (let zipcodeCTAButton of $(this.zipcodeCTAButtons)) {
      zipcodeCTAButton.hidden = hide;
    }
  }

  public updateAnalytics(analyticsStep?: string, planType?: string, trialElligibility?: boolean): void {
    try {
      let subObj = {
        planType: planType,
        isPrebookReq: this.isPrebookReq,
        isTrialElligible: trialElligibility,
        isEmployee: this.isUserEmployee,
        monthlyPlanPrice: this.analyticsMonthlyPrice,
        annualPlanPrice: this.analyticsAnnualPrice,
        isAnnualDiscounted: this.isAnnualDiscountedPrice,
        isMonthlyDiscounted: this.isMonthlyDiscountedPrice,
        monthlyDiscountMonths: this.monthlyDiscountDuration ? this.monthlyDiscountDuration : 0,
        annualDiscountMonths: this.annualDiscountDuration ? Number(this.annualDiscountDuration) * 12 : 0,
        isExtendedTrial: this.isExtendedTrial,
        trialExtDuration: this.extendedTrialDuration ? Number(this.extendedTrialDuration) : 0,
        campaignType: this.analyticsCampaignType
      };
      const impressionsObj = {
        snapBanner: this.enableSnap && this.isSnapEligibleForBanner ? 'gap' : ''
      };
      if (window['AB'] && window['AB']['DATALAYER']) {
        if (analyticsStep === 'firstLanding') {
          setTimeout(function () {
            window['AB']['DATALAYER'].updateAnalyticsSubscriptionInfo('landing', subObj, impressionsObj);
          }, 1100);
        } else if (analyticsStep === 'nextPageConfirm') {
          localStorage.setItem('freshpass-analytics-confirmation', JSON.stringify(subObj));
        } else {
          window['AB']['DATALAYER'].updateAnalyticsSubscriptionInfo(analyticsStep, subObj, impressionsObj);
        }
        this.analyticsCurrentStep = analyticsStep;
        this.analyticsNextStep = '';
      } else if (analyticsStep === 'landing') {
        localStorage.setItem('analyticsLPpageLoad', JSON.stringify(subObj));
      }
    } catch {
      console.error('Error while udpating analytics');
    }

  }

  public analyticsSisterBannerTracking() {
    if (window['AB']['DATALAYER']) {
      window['AB']['DATALAYER'].setLinkClickEvents(`freshpass-sister-store-from:${this.currentBanner}|${this.deliveryBanner}`);
    }
  }

  // --------------------------------------------------------------------------
  /**
   * Initialise Tooltip icon events
   */
  // --------------------------------------------------------------------------
  public initialiseTooltipEvents() {
    const tooltip = '.freshPassTooltip';
    let tooltipPopupTriggeringElement = null;
    if ($(tooltip).length) {
      // Initialise icon tooltip
      $(tooltip).each(function (e) {
        $(this).tooltip({
          trigger: 'hover click',
          template: '<div class="tooltip freshpass-tiles__tooltipIcon" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
          html: true,
          container: $(this).closest('.freshpass-tiles__static__column')
        });
        //changes to shift focus on to tooltip modal for ADA.
        $(this).on('click', function () {
          if (tooltipPopupTriggeringElement === null) tooltipPopupTriggeringElement = $(this);
          $('.tooltip-inner-info-content').attr("tabindex", '-1').focus();
          $('.tooltip-inner').attr('aria-hidden', 'false');
          $(this).attr('aria-expanded', 'true');

        });
        $(this).keypress((e) => {
          const enterBtn = 13;
          if (e.which === enterBtn) {
            if (tooltipPopupTriggeringElement === null) tooltipPopupTriggeringElement = $(this);
            $('.tooltip-inner-info-content').attr("tabindex", '-1');
            $('.tooltip-inner').attr('aria-hidden', 'false');
            $(this).attr('aria-expanded', 'true');
            $('dismissTooltip').focus();
            //init dismisstoTooltip event when it's open
          }
        })
        $(document).on('keypress', '.dismissTooltip', function (e) {
          const enterBtn = 13;
          if (e.which === enterBtn) {
            const idOfElement = $(this).parent().parent().attr('id');
            $('*[aria-describedby="' + idOfElement + '"]').tooltip('hide');
            tooltipPopupTriggeringElement.focus();
            tooltipPopupTriggeringElement = null;
            $('.freshPassTooltip').attr('aria-expanded', 'false').focus();
          }
        });
      })


      // On click event for dismissing tooltip on pressing 'OK' and bring back focus on to info icon.
      $(document).on('click', '.dismissTooltip', function () {
        const idOfElement = $(this).parent().parent().attr('id');
        $('*[aria-describedby="' + idOfElement + '"]').tooltip('hide');
        if (tooltipPopupTriggeringElement) {
          tooltipPopupTriggeringElement.focus();
          tooltipPopupTriggeringElement = null;
        }
        $('.freshPassTooltip').attr('aria-expanded', 'false').focus();

      });

      // On click event for dismissing tooltip on click outside
      $(document).on('click', function (e) {
        $('[data-toggle=tooltip]').each(function () {
          // hide any open tooltips anywhere else in the body is clicked
          if (!$(this).is(e.target) && $(this).has(e.target).length === 0 &&
            $('.tooltip').has(e.target).length === 0 && !$('.freshPassTooltip').is(e.target)) {
            $(this).tooltip('hide').attr('aria-expanded', 'false');
            if (tooltipPopupTriggeringElement) {
              tooltipPopupTriggeringElement.focus();
              tooltipPopupTriggeringElement = null;
            }
          }
          // On click event on icon
          if ($(this).is(e.target)) {
            $('.dismissTooltip').attr("tabindex", "0");
            $(this).attr('aria-expanded', (i, attr) => {
              if (attr === true) {
                tooltipPopupTriggeringElement.focus();
                tooltipPopupTriggeringElement = null;
              }
              return attr === 'true' ? 'false' : 'true';
            });
          }
        });
      });
    }
  }

  // --------------------------------------------------------------------------
  /**
   * Helper function to return the trial duration.  Will return the extended
   * if enabled and present.  Otherwise, return the default
   */
  // --------------------------------------------------------------------------
  getTrialDuration() {
    let trialDuration = this.regularTrialDuration;

    if (this.isExtendedTrial)
      trialDuration = this.extendedTrialDuration;

    this.trialDuration = trialDuration;
    this.trialDurationInt = parseInt(this.trialDuration);
    return trialDuration;
  }

  // --------------------------------------------------------------------------
  /**
   * Returns the start trial message with it optionally dynamically updated
   * with trial length.  This is currently used on the buttons
   * 'Start X-Day FREE Trial';
   */
  // --------------------------------------------------------------------------
  getZipCta() {
    let zipCtaMessage;
    let trialDuration = this.getTrialDuration();

    if (this.isValidTrialDuration()) {
      zipCtaMessage = this.zipCtaFreeTrial.replace('{trial-duration}', trialDuration);
    } else {
      zipCtaMessage = this.zipCtaRegular;
    }

    return zipCtaMessage;
  }

  // --------------------------------------------------------------------------
  /**
   * Returns the payment card will be charged message with it optionally
   * dynamically updated with trial length.
   * 'Note: Your payment card will not be charged until your Free X-Day Trial has ended.'
   */
  // --------------------------------------------------------------------------
  getPaymentNote() {
    let paymentNoteMessage;
    let trialDuration = this.getTrialDuration();

    if (this.isValidTrialDuration()) {
      paymentNoteMessage = this.paymentNote.replace('{trial-duration}', trialDuration);
    } else {
      paymentNoteMessage = this.paymentNoteNoTrial;
    }

    return paymentNoteMessage;
  }

  // --------------------------------------------------------------------------
  /**
   * Returns the start trial message with it optionally dynamically updated
   * with trial length. This is currently used on the buttons when in the
   * individual plan selection screen
   * 'Start {trialduration}-day Free Trial'
   *
   * NOTE: The authoring property has "annual" but it is also used for
   * monthly - we should either update the property to a more generic name or
   * also allow a monthly version as well
   */
  // --------------------------------------------------------------------------
  getPlanCta(planTrialDuration, promoCategory) {
    let planCtaMessage;

    if (this.isValidTrialDuration()) {
      planCtaMessage = this.annualPlanCtaFreeTrial.replace('{trial-duration}', planTrialDuration);
    } else {
      planCtaMessage = this.annualPlanCtaRegular;
    }
    if (promoCategory && promoCategory.toLowerCase().includes('snap') && !this.isSnapVerified) {
      planCtaMessage = "Learn More";
    }

    return planCtaMessage;
  }

  isValidTrialDuration() {
    return this.landingUser.isEligibleForFreeTrial === true && !this.isNoFreeTrial && this.trialDurationInt > 0
  }

  checkPrebookRedirect() {
    const prebookParams = new URLSearchParams(this.windowUtil.getWindowSearchParams())
    if (prebookParams.has('pageRequest')) {
      this.isPrebookReq = prebookParams.get('pageRequest')
    }
  }

  setOnePlanCampaign(availablePlans) {
    this.isOnePlanCampaign = true;
    this.availablePlans = availablePlans;
    this.mapAvailablePlans(this.availablePlans);
  }

  setCampaignOptions(campaignOptions) {
    if (campaignOptions?.campaignRules?.isNoTrial) {
      this.isNoFreeTrial = true;
    }
    if (campaignOptions?.campaignTitle && campaignOptions.campaignTitle.length > 0) {
      this.isCampaignTitle = true;
      this.campaignTitle = campaignOptions.campaignTitle;

      $('.notification-alert').addClass('d-none');
    }

    if (campaignOptions?.campaignRules?.showCampaignPlanOnly) {
      this.isBDA = true;
    }
  }

  setLocalStorageIfDiscountCampaignAndActive() {
    const params = new URLSearchParams(this.windowUtil.getWindowSearchParams())

    if (params.has(this.programDisplayData?.promotionKeys?.discountCode)) {
      localStorage.setItem('isDiscountCampaignAndActive', 'true');
    }
  }


  displaySnackBarErrorMsg(error) {
    if (error?.errorMessage) {
      this._freshpassModalService.setSnackBar({
        "message": error.errorMessage,
        "type": "errorInfo",
        "show": true,
        "closeOption": true,
        "from": "promoExpired",
        "timer": 0,
        "closeOnClick": false,
        "topVH": "15vh",
        "rightVH": '1vh',
        "theme": "black"
      })
    }
  }

  displayErrorModal(error) {
    this._freshpassModalService.openModalWithComponent(NotificationModalComponent, {
      class: 'notif-modal modal-dialog-centered',
      ariaLabelledBy: 'modal-label-modal-notification',
      centered: true,
      keyboard: true,
      initialState: {
        errorMsg: error.errorMessage ? error.errorMessage : "",
        campaignTitle: this.campaignTitle ? this.campaignTitle : ""
      }
    });
  }

  createNewAccount() {
    window['AB']['DATALAYER'].setLinkClickSignInEcom('create-account');
  }

  private showLoader() {
    this.numberOfCallsBeingLoaded++;
  }

  // --------------------------------------------------------------------------
  /**
   * Hide the loader icon
   */
  // --------------------------------------------------------------------------
  private hideLoader() {
    this.numberOfCallsBeingLoaded--;

    if (this.numberOfCallsBeingLoaded < 0) {
      this.numberOfCallsBeingLoaded = 0;
    }
  }

  public setSubscriptionLanding(plansInfo: any) {
    if (this.step !== this.PAYMENT && !window.location.pathname.includes('manage/govassist')) {
      this.updateAnalytics('landing');
    }
    this.analyticsFirstLanding = false;

    this.setSubscriptionLandingV3(plansInfo);
  }

  public setSubscriptionLandingV3(plansInfo: any) {
    let zipDescription = this.getZipDescriptionV3(plansInfo);
    let taxMessage = this.getTaxMessageV3(plansInfo);

    // Even if the user is not targeted for a "discount", a check has to be made if there is an extended
    // trial and if so, generate the Offer Ends message
    if (this.signUpBeforeDate) {
      const specialOfferMessage = 'Offer ends {date}';
      this.subscriptionLanding.discountedPriceOffer = specialOfferMessage?.replace('{date}', moment(this.signUpBeforeDate).format('L'));
    }

    if (plansInfo.discountedTargetUser) {
      this.subscriptionLanding.discountedPriceTargetUser = true;

      //remove '.' from EOL if snap or one plan campaign
      if (this.isOnePlanCampaign || this.isSnapVerified) {
        zipDescription = zipDescription.lastIndexOf('.') === (zipDescription.length - 1) ? zipDescription.slice(0, -1) : zipDescription;
      }
      this.subscriptionLanding.discountedPriceStrike = zipDescription.replace("Just ", "");
      this.priceInfo = this.getPriceInfo(plansInfo);
      this.subscriptionLanding.discountedPriceZipDescription = zipDescription;
      this.subscriptionLanding.discountedPriceZipDescriptionTax = taxMessage;
    } else {
      this.subscriptionLanding.discountedPriceStrike = zipDescription.replace("Just ", "");
      this.priceInfo = this.getPriceInfo(plansInfo);
      this.zipDescription = zipDescription;
      this.zipDescriptionSrLabel =this.zipDescription
      .replace(/<[^>]*>?/gm, '') // Remove HTML tags
      .replace(/\/year/g, ' per year') // Replace "/year" with " per year"
      .replace(/\/month/g, ' per month');  // Replace "/month" with " per month"
      this.taxDescription = taxMessage;
    }
  }

  public getPriceInfo(plansInfo) {
    let priceInfo = "";
    let annualInfo = plansInfo['annualplan'];
    if (annualInfo) {
      priceInfo = `Annual Price Discounted Price is ${plansInfo.annualplan.planPrice} dollars and original price is ${plansInfo.annualplan.regularPlanPrice} dollars in the first year`;
    }
    return priceInfo;
  }

  public getZipDescriptionV3(plansInfo: any) {
    let annualInfo = plansInfo['annualplan'];
    let monthInfo = plansInfo['monthlyplan'];
    let isAnnualDiscountRate = false;
    let isMonthlyDiscountRate = false;
    // const bothSnapVerified = annualInfo?.iSSNAPVerified && monthInfo?.iSSNAPVerified;
    //variables to determine if the rate is discounted
    if (annualInfo) {
      isAnnualDiscountRate = annualInfo.planPrice !== annualInfo.regularPlanPrice
    }
    if (monthInfo) {
      isMonthlyDiscountRate = monthInfo.planPrice !== monthInfo.regularPlanPrice
    }

    let trialDuration = this.getTrialDuration();

    // Get the zip description - template which will be filled out:
    // Just {annual-plan-price}{conjunction}{monthly-plan-price}{extended-trial}.
    let zipDescription = 'Just {annual-plan-price}{conjunction}{monthly-plan-price}{extended-trial}.';

    // The conjunction in the message is the optional " or " which will only have a value if both
    // the annual and monthly plan have values
    let conjunction = '';

    // The optional annual and monthly prices
    let annualPlanPrice = '';
    let monthlyPlanPrice = '';

    // If extended trial, create the optional message with the trial duration and include line break to move to next line
    let extendedTrial = '';
    if (this.isExtendedTrial)
      extendedTrial = ', <br/>' + this.zipExtendedTrial.replace('{trial-duration}', trialDuration);

    if (plansInfo.discountedTargetUser) {
      if (plansInfo.hasDiscountedAnnualPlan && annualInfo) {
        // Create the optional annual price message
        if (isAnnualDiscountRate) {
          annualPlanPrice = `<span>$${annualInfo.planPrice}</span> <s>$${annualInfo.regularPlanPrice}</s> <span>${annualInfo.planPriceDetail}</span>`;
        } else {
          annualPlanPrice = `$${annualInfo.regularPlanPrice}/year`;
        }
        //snapPromoType has a different message from other discount types. it includes monthly and annual message: 'Just $99/year or $5.99 $12.99/month'
      } else if (this.isSnapVerified) {
        annualPlanPrice = `$${annualInfo.regularPlanPrice}/year`;
      }
      if (plansInfo.hasDiscountedMonthlyPlan && monthInfo) {
        // Create the optional monthly price message
        if (isMonthlyDiscountRate && this.isSnapVerified) {
          monthlyPlanPrice = `<span><span class="sr-only">Discount Price</span>$${monthInfo.planPrice}</span> <s><span class="sr-only">Original Price</span>$${monthInfo.regularPlanPrice}</s>/month`;
        } else if (isMonthlyDiscountRate) {
          monthlyPlanPrice = `<span><span class="sr-only">Discount Price</span>$${monthInfo.planPrice}</span> <s><span class="sr-only">Original Price</span>$${monthInfo.regularPlanPrice}</s> <span>${monthInfo.planPriceDetail}</span>`;
        } else {
          monthlyPlanPrice = `$${monthInfo.regularPlanPrice}/month`;
        }
      }
      // If both annual and monthly prices, add the "or" conjunction between the values OR is Snap Promo option
      if ((plansInfo.hasDiscountedAnnualPlan && plansInfo.hasDiscountedMonthlyPlan)) {
        conjunction = " or </br> ";
      }
      if (this.isSnapVerified) {
        conjunction = " or ";
      }
    } else {
      if (annualInfo) {
        // Create the optional annual price message
        let price = annualInfo.pricingDetailLine1.replace(/[\(\)']+/g, '');
        const annualPrice = this.isAnnualDiscountedPrice ? `<s><span class="sr-only">Original Price</span>$${annualInfo.regularPlanPrice}</s>` + ' ' + `<span class="employee-discount"><span class="sr-only">Discount Price</span>${price}</span>` : price;
        annualPlanPrice = (this.isUserEmployee && this.isAnnualDiscountedPrice) ? annualPrice : price;
      }

      if (monthInfo) {
        // Create the optional monthly price message
        let price = monthInfo.pricingDetailLine1.replace(/[\(\)']+/g, '');
        let monthlyPrice = this.isMonthlyDiscountedPrice ? `<s><span class="sr-only">Original Price</span>$${monthInfo.regularPlanPrice}</s>` + ' ' + `<span class="employee-discount"><span class="sr-only">Discount Price</span>${price}</span>` : price;
        monthlyPlanPrice = (this.isUserEmployee && this.isMonthlyDiscountedPrice) ? monthlyPrice : price;
      }

      if (annualInfo && monthInfo || this.isSnapVerified) {
        conjunction = " or ";
      }
    }

    // Fill out the template

    // Set the optional annual price in the zip description
    zipDescription = zipDescription.replace('{annual-plan-price}', annualPlanPrice);

    // Set the optional conjunction in zip description
    zipDescription = zipDescription.replace('{conjunction}', conjunction);

    // Set the optional monthly price in the zip description
    zipDescription = zipDescription.replace('{monthly-plan-price}', monthlyPlanPrice);

    // Set optional extended trial in zip description:
    zipDescription = zipDescription.replace('{extended-trial}', extendedTrial);

    return zipDescription;
  }

  getTaxMessageV3(plansInfo: any) {
    let annualInfo = plansInfo['annualplan'];
    let monthInfo = plansInfo['monthlyplan'];

    let trialDuration = this.getTrialDuration();

    // Get the tax message for when there is a trial  - template which will be filled out:
    // +Tax, Charged after {trial-duration}-day free trial. Auto-renews at {annual-plan-price}{conjunction}{monthly-plan-price}.
    let trialTaxMessage = this.programDisplayData?.subscribeData?.trialTaxMessage;

    // Get the tax message for when there is no trial  - template which will be filled out:
    // +Tax, Auto-renews at {annual-plan-price}{conjunction}{monthly-plan-price}.
    let taxMessage = this.programDisplayData?.subscribeData?.taxMessage;

    // Determine which tax meesage to use based on whether there is a trial
    let message = this.isValidTrialDuration() ? trialTaxMessage : taxMessage;

    // The conjunction in the message is the optional " or " which will only have a value if both
    // the annual and monthly plan have values
    let conjunction = '';

    // The optional annual and monthly prices
    let annualPlanPrice = '';
    let monthlyPlanPrice = '';

    if (plansInfo.discountedTargetUser) {
      // If discount from both plans, meesagge will contain both values - add " or " conjunction
      if ((plansInfo.hasDiscountedAnnualPlan && plansInfo.hasDiscountedMonthlyPlan && !this.isOnePlanCampaign) || this.isSnapVerified)
        conjunction = " or ";
      if ((plansInfo.hasDiscountedAnnualPlan && !plansInfo.hasDiscountedMonthlyPlan && !this.isOnePlanCampaign) || this.isSnapVerified)
        conjunction = " or ";

      // Get the optional annual price
      if (annualInfo && (plansInfo.hasDiscountedAnnualPlan || this.isSnapVerified))
        annualPlanPrice = `$${annualInfo.regularPlanPrice}/year`;

      // Get the optional monthly price
      if (monthInfo) {
        if (plansInfo.hasDiscountedMonthlyPlan && this.isSnapVerified) {
          monthlyPlanPrice = `$${monthInfo?.planPrice}/month`;
        } else {
          monthlyPlanPrice = `$${monthInfo?.regularPlanPrice}/month`;
        }
      }
    } else {
      if (!this.isOnePlanCampaign) {
        conjunction = " or ";
      }

      if (annualInfo)
        annualPlanPrice = annualInfo.pricingDetailLine1;

      if (monthInfo)
        monthlyPlanPrice = monthInfo.pricingDetailLine1;
    }

    // Fill out the template

    // // Set the optional trial duration in the tax message
    if (this.landingUser.isEligibleForFreeTrial)
      message = message.replace('{trial-duration}', trialDuration);

    // Set the optional annual price in the tax message
    message = message.replace('{annual-plan-price}', annualPlanPrice);

    // Set the optional conjunction in the tax message
    message = message.replace('{conjunction}', conjunction);

    // Set the optional monthly price in the tax message
    message = message.replace('{monthly-plan-price}', monthlyPlanPrice);
    
    //set specific tax message for snap
    if (annualInfo?.iSSNAPVerified || monthInfo?.iSSNAPVerified) {
      if (this.landingUser.isEligibleForFreeTrial) {
        message = this.programDisplayData?.freshpassData?.snapTrialDescription;
        message = message.replace("{trial-duration}", trialDuration);
      } else {
        message = this.programDisplayData?.freshpassData?.snapNonTrialDescription;
      }
    }

    return message;
  }

  isObjectEmpty = function (data) {
    return typeof (data) === 'undefined' || data === null || Object.keys(data).length === 0;
  }

  getDisplayMessageError = (errorCode) => {
    switch (errorCode) {
      case this.programDisplayData?.errorCode?.UNKNOWN_ERROR_CODE:
        return this.programDisplayData?.errorMessages?.UNKNOWN_ERROR_MESSAGE;
      case this.programDisplayData?.errorCode?.CARD_CANNOT_BE_ACCEPTED_CODE:
        return this.programDisplayData?.errorMessages?.CARD_CANNOT_BE_ACCEPTED_MESSAGE;
      case this.programDisplayData?.errorCode?.OFFER_NO_LONGER_AVAILABLE_CODE:
        return this.programDisplayData?.errorMessages?.OFFER_NO_LONGER_AVAILABLE_MESSAGE;
      case this.programDisplayData?.errorCode?.INVALID_BANNER_CODE:
        const curBannerPlural = pluralizeBannerName(this.currentBanner)
        this.invalidBannerInput = true;
        return this.programDisplayData?.errorMessages?.INVALID_BANNER_MESSAGE?.replace("{banner}", curBannerPlural);
      default:
        return this.programDisplayData?.errorMessages?.DEFAULT_ERROR_MESSAGE;
    }
  };

  checkIfB2B() {
    this.isB2B = this.authService.checkB2B();
  }

  setEcommRedirectURLCookie() {
    let ecomCookieUrl;
    let currentPagePath = window.location.pathname + window.location.search;

    if (this.isB2B) {
      ecomCookieUrl = 'ACI_S_B_ECommRedirectURL';
    } else {
      ecomCookieUrl = 'ACI_S_ECommRedirectURL'
    }
    window['AB']['COMMON'].setCookie(ecomCookieUrl, encodeURI(currentPagePath));
  }

  focusOnBackButton() {
    const isBackButtonVisible = this.backButtonRef?.nativeElement?.offsetParent !== undefined;
    if (isBackButtonVisible) {
      this.backButtonRef.nativeElement.focus();
    }
  }

  analyticsLinkTracking() {
    if (window['AB'] && window['AB']['DATALAYER']) {
      window['AB']['DATALAYER'].analyticsCTATracking(`cta:${window['AB']['DATALAYER'].initPathSections(true).join(':')}|link|see-if-im-eligible`);
    }
  }


  checkRedirectionPath(queryString: string = window.location.search, referrerPath = document.referrer) {
    if (this.isRedirectedFromPartnersPage()){
      this.webSource.param = queryString;
      this.webSource.path = referrerPath;
    }
  }

  redirectToChangePlanWithReferrerPath() {
    let referrerPath = '';
    if (this.webSource?.path && this.webSource?.param) {
      const extractedPath = new URL(this.webSource.path).pathname;
      referrerPath = this.webSource.param + '&referrer=' + extractedPath;
    }
    this.windowUtil.setWindowLocationHref(this.programDisplayData?.urlPath?.CHANGE_PLAN_PATH + referrerPath);
  }

  isRedirectedFromPartnersPage(searchParams: string = window.location.search): boolean {
    const urlParams = new URLSearchParams(searchParams);
    return urlParams.get('webSource') === this.programDisplayData?.WEBSOURCE?.EXPEDIA;
  }

  goToSubscriptionLandingStep() {
    this.setStep(this.SUBSCRIPTION_LANDING);  
  }

  setPrebookLocalStorage() {
    if (this.enableForUPlus) {
      localStorage.setItem('forUPlusPrebookSuccess', 'true');  
    } else {
      localStorage.setItem('freshpassPrebookSuccess', 'true');
    }
  }
}
